import SvgIcon, {SvgIconProps} from '@mui/material/SvgIcon';
import React from 'react';

export default function OpenFolderIcon(props: SvgIconProps) {
   return (
      <SvgIcon {...props} width="24" height="24" viewBox="0 0 64 64">
         <g fill="#d69661">
            <path d="M48.48 14c2.498 0 4.52 2.224 4.52 4.978v31.04c0 2.746-2.02 4.979-4.52 4.979H7.516C5.024 54.997 3 52.765 3 50.018V18.269c0-2.754 2.02-4.272 4.516-4.272" />
            <path d="M18.26 8c.842 0 1.525.75 1.525 1.68l10 10.709c0 .926-.684 1.678-1.525 1.678H4.522c-.84 0-1.521-.752-1.521-1.678V9.68c0-.93.682-1.68 1.521-1.68z" />
         </g>
         <path
            d="M56.41 22.944c2.496 0 4.518 2.224 4.518 4.978l-6.967 22.1c-.76 1.979-3.02 4.979-5.52 4.979H7.516C5.024 55.001 3 52.769 3 50.022l6.969-22.1C11 26 12.989 22.944 15.485 22.944"
            fill="#e5b687"
         />
         <rect x="0" y="0" width="64" height="64" fill="rgba(0, 0, 0, 0)" />
      </SvgIcon>
   );
}
